<template>
<!-- 通道费发票管理 -->
<div class="home-page-container">
  <div class="channel-invoice-wrapper">
    <el-row :gutter="20">
      <!-- 油品发票金额 -->
      <el-col :span="6">
        <div class="invoice-balance">
          <div class="title">上月可开票金额(元)</div>
          <div class="balance">
            <span class="flag">¥</span>
            <span>{{invoiceBalacne}}</span>
          </div>
          <el-button size="mini" type="primary" class="invoice-btn" @click="applyChannelInvoice">申请开票</el-button>
        </div>
      </el-col>
      <!-- 发票抬头信息 -->
      <el-col :span="18">
        <div class="invoice-info">
          <div class="invoice-info-top">
            <span class="title">发票 *通道费发票升级为全电发票</span>
            <el-button size="mini" @click="gotoConfig">
              开票、收票信息修改<i class="el-icon-arrow-right"></i>
            </el-button>
          </div>
          <el-row>
            <el-col :span="12">
              <div class="info-item">
                <span class="label">开票抬头：</span>
                <span class="info">{{invoiceForm.sellerName}}</span>
              </div>
              <div class="info-item">
                <span class="label">纳税人识别号：</span>
                <span class="info">{{invoiceForm.sellerTaxNo}}</span>
              </div>
              <div class="info-item">
                <span class="label">地址和电话：</span>
                <span class="info">{{invoiceForm.sellerAddressPhone}}</span>
              </div>
              <div class="info-item">
                <span class="label">开户行和账号：</span>
                <span class="info">{{invoiceForm.sellerBankAccount}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <span class="label">收件人：</span>
                <span class="info">{{addressForm.addressee}}</span>
              </div>
              <div class="info-item">
                <span class="label">联系电话：</span>
                <span class="info">{{addressForm.addresseePhone}}</span>
              </div>
              <div class="info-item">
                <span class="label">邮寄地址：</span>
                <span class="info">{{addressForm.addresseeAddress}}</span>
              </div>
              <div class="info-item">
                <span class="label">电子邮箱：</span>
                <span class="info">{{addressForm.email}}</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </div>
  <el-card shadow="never" style="margin: 20px 0">
    <mer-search :searchConfig="formConfig" 
      :searchBar="searchBar" 
      @search="search" 
      @reset="reset(initQuery)" 
      @changeTime="(value,model)=>changeTime(value,'searchBar', 'applyStartTime', 'applyEndTime')" 
      :loading="tableLoading" :isLayout="true">
      <template slot="handler">
        <!-- <el-button size="mini" @click="download" icon="el-icon-download">导出</el-button> -->
          <download-button :downloadApi="downloadChannelInvoiceBillApi" :queryParams="{ ...downloadParams }"></download-button>
      </template>
      <template slot="other-search-item">
        <el-tooltip class="item" effect="light" content="最多支持以年为单位查询申请记录" placement="right">
          <i class="el-icon-question" style="margin-top: 7px;"></i>
        </el-tooltip>
      </template>
    </mer-search>
  </el-card>
  <el-card shadow="never">
    <!-- <el-tabs v-model="activeName" @tab-click="handleChangeTab">
      <el-tab-pane label="近期发票" name="lately"> -->
        <mer-table :loading="tableLoading" 
          :tableConfig="latelyTableConfig" 
          :tableData="tableData" 
          :pagination="pagination" 
          @SizeChange="handleSizeChange" 
          @PageChange="pageChange">
          <template slot="applyTime" slot-scope="{row}">
              <span>{{row.createTime | formatTime }}</span>
          </template>
          <template slot="businessName" slot-scope="{row}">
              <span>{{ businessNameList.find(item => item.value === row.businessName) ? businessNameList.find(item => item.value === row.businessName).label : '' }}</span>
          </template>
          <template slot="mailingTime" slot-scope="{row}">
              <span>{{row.mailingTime | formatTime }}</span>
          </template>
          <template slot="operate" slot-scope="{row}">
              <el-button type="text" @click="downLoadInvoice(row)">下载发票</el-button>
              <el-button type="text" @click="blushFn(row)">冲红</el-button>
          </template>
        </mer-table>
      <!-- </el-tab-pane>
      <el-tab-pane label="历史发票" name="history"> -->
        <!-- table 表格 -->
        <!-- <mer-table :loading="tableLoading" 
          :tableConfig="tableConfig" 
          :tableData="tableData" 
          :pagination="pagination" 
          @SizeChange="handleSizeChange" 
          @PageChange="pageChange">
          <template slot="applyTime" slot-scope="{row}">
              <span>{{row.createTime | formatTime }}</span>
          </template>
          <template slot="businessName" slot-scope="{row}">
              <span>{{ businessNameList.find(item => item.value === row.businessName) ? businessNameList.find(item => item.value === row.businessName).label : '' }}</span>
          </template>
          <template slot="mailingTime" slot-scope="{row}">
              <span>{{row.mailingTime | formatTime }}</span>
          </template>
        </mer-table>
      </el-tab-pane>
    </el-tabs> -->
  
  </el-card>
  <apply-invoice v-if="invoiceShow" @close="invoiceShow=false;getInvoiceBlance();search()"></apply-invoice>

  <el-dialog title="发票冲红" :visible.sync="showBlusDialog" >
    <el-form :model="blushForm" label-width="150px">
      <el-form-item label="冲红原因:" prop="remarks" required>
        <el-input type="textarea" v-model="blushForm.remarks" maxlength="200"  show-word-limit></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" size="mini" @click="showBlusDialog = false">取消</el-button>
      <el-button type="primary" size="mini" :loading="submitLoading" @click="blushSubmit">确认</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import listPage from '@/mixins/listPage'
import queryMix from '@/views/finance/mixins/query';
import { redWithRemarks, chanInvoiceRecentRecordsWithPage, getChannelInvoiceBalacneApi,getQuerySendStatusApi,getQueryInvoiceStatusApi,getChannelInvoiceListApi,downloadChannelInvoiceBillApi, getAllInvoiceInfoApi, getAllInvoiceAddressApi } from '@/api/finance'
import ApplyInvoice from './components/channelInvoice/applyInvoice'
import moment from 'moment'

const orderSourceList = [{
  label: '全部',
  value: '',
}, {
  label: '是',
  value: '-202',
}, {
  label: '否',
  value: '-101'
}]
const businessNameList = [{
  label: '全部',
  value: '',
}, {
  label: '是',
  value: 'DY',
}, {
  label: '否',
  value: 'TY'
}]

// 查询表单配置
let formConfig = [
  {label: '油站',type: 'select',modelName: 'gasId',placeholder: '全部',selectOptions: [],define: true,selectLabel: 'gasName',selectValue: 'gasId'},
  {label: '发票状态',type: 'select',modelName: 'invoiceStatus',placeholder: '全部',selectOptions: [],define: true,selectLabel: 'label',selectValue: 'value'},
  // {label: '邮寄状态',type: 'select',modelName: 'mailingStatus',placeholder: '全部',selectOptions: [],define: true,selectLabel: 'label',selectValue: 'value'},
  { label: '发票抬头', type: 'input', modelName: 'buyerName', placeholder: '请输入发票抬头' },
  {label: '是否抖音模式结算',type: 'select',modelName: 'orderSource',placeholder: '全部',selectOptions: orderSourceList, define: true,selectLabel: 'label',selectValue: 'value', labelWidth: '150px'},
  {label: '申请时间',type: 'date',modelName: 'invoiceTime',model: '',dateType: 'datetimerange',format: 'yyyy-MM-dd HH:mm:ss',pickerOptions:{}, clearable:false},
]
// 表格参数配置
let tableConfig = [
  {label: '申请时间',prop: 'createTime',fixed: 'left',width: 150,slot:'applyTime'},
  {label: '开票类型',prop: 'invoiceTypeCodeName',width: 136},
  {label: '发票类型',prop: 'invoiceTypeDesc',width: 136},
  {label: '是否抖音模式结算',slot: 'businessName',width: 136},
  {label: '对应订单交易周期',prop: 'invoiceDateRange',width: 210},
  {label: '发票号码',prop: 'invoiceNo',width: 136},
  {label: '发票抬头',prop: 'buyerName',width: 136},
  {label: '申请开票金额(元)',prop: 'invoiceTotalPrice',width: 136},
  {label: '税额(元)',prop: 'invoiceTotalTax',width: 136},
  {label: '价税合计(元)',prop: 'invoiceTotalPriceTax',width: 136},
  {label: '发票状态',prop: 'invoiceStatusDesc',width: 136},
  {label: '邮寄状态',prop: 'mailingStatusDesc',width: 136},
  {label: '备注',prop: 'remarks',width: 136},
  {label: '邮寄日期',prop: 'mailingTime',width: 150,slot:'mailingTime'},
  {label: '快递单号',prop: 'expressNo',width: 136},
  {label: '快递名称',prop: 'expressName',width: 136},
  {label: '发票详情',prop: 'invoiceDetails',width: 150}
  // {label: '冲红原因',prop: 'result',width: 150},
  // {label: '操作',prop: 'operate',width: 180, slot:'operate',fixed: 'right'},
]
let latelyTableConfig = [
  {label: '申请时间',prop: 'createTime',fixed: 'left',width: 150,slot:'applyTime'},
  {label: '开票类型',prop: 'invoiceTypeDesc',width: 136},
  {label: '发票类型',prop: 'invoiceTitleTypeDesc',width: 136},
  {label: '是否抖音模式结算',prop: 'orderSource',width: 136},
  {label: '对应订单交易周期',prop: 'invoiceDateRange',width: 210},
  {label: '发票号码',prop: 'invoiceNo',width: 136},
  {label: '发票抬头',prop: 'buyerName',width: 136},
  {label: '销方单位名称',prop: 'sellerName',width: 136},
  {label: '申请开票金额(元)',prop: 'invoiceTotalPrice',width: 136},
  {label: '税额(元)',prop: 'invoiceTotalTax',width: 136},
  {label: '价税合计(元)',prop: 'invoiceTotalPriceTax',width: 136},
  {label: '发票状态',prop: 'invoiceStatusDesc',width: 136},
  {label: '备注',prop: 'remarks',width: 136},
  {label: '发票详情',prop: 'invoiceDetail',width: 150},
  {label: '冲红原因',prop: 'invoiceInvalidReason',width: 150},
  {label: '操作',prop: 'operate',width: 180, slot:'operate',fixed: 'right'}
]
export default {
  name: 'invoice_channelInvoice',
  mixins: [listPage, queryMix],
  components:{
    ApplyInvoice
  },
  data() {
    return {
      activeName: 'lately',
      businessNameList,
      downloadChannelInvoiceBillApi,
      invoiceTime: '',
      formConfig: formConfig,
      tableConfig: tableConfig,
      latelyTableConfig: latelyTableConfig,
      invoiceBalacne: 0,
      allQueryProps: {},
      invoiceShow: false,
      invoiceForm:{
        sellerName:'',
        sellerBankAccount:'',
        sellerTaxNo:'',
        sellerAddressPhone:''
      },
      addressForm:{
        addressee:'',
        addresseePhone:'',
        addresseeAddress:'',
        email:''
      },
      showBlusDialog: false, // 冲红弹窗
      blushForm: {
        remarks: ''
      },
      submitLoading: false,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime()
          if (maxDate) {
            this.selectDate = ''
          }
        },
        // 限制时间选择范围31天
        disabledDate: (time) => {
          if (this.selectDate !== '') {
            const one = 365 * 24 * 3600 * 1000
            const minTime = this.selectDate - one
            const maxTime = this.selectDate + one
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      }
    }
  },
  created() {
    this.$track.pageViewEvent('通道费发票管理', '1621476241')
    this.initPage()
    this.initInvoiceAndAddress() //解决二次刷新，数据丢失
  },
  activated(){
    this.initInvoiceAndAddress()
  },
  methods: {
    handleChangeTab (e) {
      this.activeName = e.name
      this.searchBar['gasId'] = ''
      this.searchBar['pageIndex'] = 1
      this.searchBar['pageSize'] = 10
      if (e.name === 'lately') {
        this.formConfig[3].modelName = 'orderSource'
        this.formConfig[3].selectOptions = orderSourceList
        this.businessNameList = orderSourceList
        delete this.searchBar['businessName'] && this.searchBar['businessName']
        this.initList(chanInvoiceRecentRecordsWithPage, false)
      } else {
        this.formConfig[3].modelName = 'businessName'
        this.formConfig[3].selectOptions = businessNameList
        this.businessNameList = businessNameList
        delete this.searchBar['orderSource'] && this.searchBar['orderSource']
        this.initList(getChannelInvoiceListApi, false)
      }
    },
    initPage() {
      this.getQueryProps()
      this.initQuery()
      // this.initList(getChannelInvoiceListApi, false)
      this.initList(chanInvoiceRecentRecordsWithPage, false)
      // this.getInvoiceBlance()
      // this.ininInvoiceAndAddress()
    },
    // 设置默认查询条件，默认时间间隔当前自然月
    initQuery() {
      this.invoiceTime = ''
      this.initMonth()
      const {invoiceTime,pickerOptions} = this
      const initObj = { invoiceTime:[invoiceTime,pickerOptions] }
      this.setSearchConfig(initObj)
      // 获取查询条件：油站
      this.getAllGasStations()
    },
    // 初始化上月开票金额、发票信息and邮寄地址
    initInvoiceAndAddress(){
      this.getInvoiceBlance()
      this.getAllInvoice()
      this.getAllAddress()
    },
    // 获取查询条件：油站 发票状态 邮寄状态
    getQueryProps() {
      // this.getQuerySendStatus()
      this.getQueryInvoiceStatus()
    },
    initMonth(){
      const start = moment().month(moment().month() - 1).startOf('month').format('YYYY-MM-DD HH:mm:ss')
      const end = moment().month(moment().month() - 1).endOf('month').format('YYYY-MM-DD HH:mm:ss')
      this.invoiceTime = [start,end]
      this.searchBar['applyStartTime'] = start
      this.searchBar['applyEndTime'] = end
    },
    //获取查询条件：邮寄状态
    async getQuerySendStatus(){
      try{
        const { code, result={} } = await getQuerySendStatusApi()
        if(code !== 200) return
        const initObj = { mailingStatus: this.optionsWrapper(result) }
        this.setSearchConfig(initObj)
      }catch(e){
        console.log(e)
      }
    },
    //获取查询条件：发票状态
    async getQueryInvoiceStatus(){
      try{
        const { code, result={} } = await getQueryInvoiceStatusApi()
        if(code !== 200) return
        const initObj = { invoiceStatus: this.optionsWrapper(result) }
        this.setSearchConfig(initObj)
      }catch(e){
        console.log(e)
      }
    },
    // 获取上月可开发票金额
    async getInvoiceBlance() {
      try {
        const lastMonthStartDate = moment().month(moment().month() - 1).startOf('month').format('YYYY-MM-DD HH:mm:ss');
        const lastMonthEndDate = moment().month(moment().month() - 1).endOf('month').format('YYYY-MM-DD HH:mm:ss');
        const data = {
          applyStartTime: lastMonthStartDate,
          applyEndTime: lastMonthEndDate
        }
        const { code, result = '0.00' } = await getChannelInvoiceBalacneApi(data)
        if(code !== 200) return
        this.invoiceBalacne = result
      } catch (err) {
        console.log(err)
      }
    },
      //获取发票信息
    async getAllInvoice(){
      try{
        const {code, result = []} = await getAllInvoiceInfoApi()
        if( code !==200 ) return
        this.invoiceForm = this.setDefaultInvoiceOrAddress(result)
      }catch(e){
        console.log(e)
      }
    },
    //获取邮寄地址
    async getAllAddress(){
      try{
        const {code, result = []} = await getAllInvoiceAddressApi()
        if( code !==200 ) return
        this.addressForm = this.setDefaultInvoiceOrAddress(result)
      }catch(e){
        console.log(e)
      }
    },
    //获取默认的发票或地址，若没有默认，取数组第一项
    setDefaultInvoiceOrAddress(arr = []){
      let needArr = []
      if(arr && arr.length){
        needArr = arr.filter((item)=>{
          return item.type === 0
        })
      }
      return needArr.length ? needArr[0] : {}
    },
    //发票列表导出
    download() {
      this.downloadFile(downloadChannelInvoiceBillApi, '通道费发票')
    },
    gotoConfig(){
      this.$track.clickEvent('开票收件信息变更', '1621476344')
      this.$router.push({path:'/invoice/invoiceConfig'})
    },
    applyChannelInvoice () {
      this.invoiceShow = true
      this.$track.clickEvent('申请开票', '1621476342')
    },
    // 下载发票
    downLoadInvoice (row) {
      if (row.invoiceSourceType !== 0) {
        this.$message.warning(`该数据为${row.invoiceSourceType === 1 ? '线下' : '历史'}开票，请联系能链商务人员线下补推发票`)
        return
      }
      if (row.pdfUrl) {
        this.downloadFile(row.pdfUrl, '通道费发票')
        const a = document.createElement('a');
        a.href = row.pdfUrl;
        a.click()
      } else {
        this.$message({
          message: `发票状态为: ${row.invoiceStatusDesc}, 无法下载`,
          type: 'error'
        })
      }
    },
    // 调冲红接口
    blushFn (row) {
      if (row.invoiceSourceType !== 0) {
        this.$message.warning(`该数据为${row.invoiceSourceType === 1 ? '线下' : '历史'}开票，请联系能链商务人员线下冲红`)
        return
      }
      this.showBlusDialog = true
      this.blushForm.serialNo = row.serialNo
    },
    blushSubmit () {
      console.log('调冲红接口', this.blushForm)
      this.submitLoading = true
      redWithRemarks({
        ...this.blushForm
      }).then(res => {
        this.submitLoading = false
        if (res.code === 200) {
          this.showBlusDialog = false
          this.initList(chanInvoiceRecentRecordsWithPage, false)
          return
        }
        this.$message({
          message: res.message,
          type: 'error'
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.home-page-container {
  margin-top: 20px;
}
.channel-invoice-wrapper {
  margin-bottom: 20px;
  box-sizing: border-box;
  .invoice-balance {
    background: #FFF;
    height: 254px;
    padding: 35px 30px;
    display: flex;
    flex-direction: column;
    .title {
      font-size: 14px;
      color: #A6A6A6;
      margin-bottom: 17px;
    }
    .balance {
      font-size: 20px;
      color: #222222;
      margin-bottom: 75px;
      .flag {
        padding-right: 5px;
        font-size: 10px;
      }
    }
    .invoice-btn {
      width: 100px;
    }
  }

  .invoice-info {
    background: #FFF;
    height: 254px;
    padding: 35px 30px;
    font-size: 12px;
    .invoice-info-top{
      margin-bottom: 35px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        border-left: 3px solid #4B7EFE;
        padding-left: 5px;
        font-weight: bold;
        font-size: 16px;
      }
    }
    .info-item {
      margin-bottom: 16px;
      display: flex;
      .label {
        color: #A6A6A6;
        white-space: nowrap;
      }
      .info {
        color: #222222;
        word-break: break-all;
      }
    }
  }
}
</style>
